import ContentUtils from '@/utils/ContentUtils.js';

export default class DateUtils {

  static august12021() {
    return 1627790400000;
  }

  static yearInDays() {
    return 365;
  }

  static toDateTime(time) {
    return ContentUtils.decodeDateTime(time);
  }

  static toDate(time) {
    return ContentUtils.decodeDate(time);
  }

  static endOfLastMonth() {
    var today = new Date();
    var year = today.getFullYear();
    return DateUtils.lastDayOfMonth(today.getMonth() - 1, year);
  }

  static startOfLastMonth() {
    var today = new Date();
    var year = today.getFullYear();
    return DateUtils.firstDayOfMonth(today.getMonth() - 1, year);
  }

  static endOfToday() {
    var today = new Date();
    today.setHours(23, 59, 59, 999);
    return today;
  }

  static startOfToday() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  static startOfMonth() {
    var today = new Date();
    var year = today.getFullYear();
    var firstOfMonth = DateUtils.firstDayOfMonth(today.getMonth(), year);
    return firstOfMonth;
  }

  static firstDayOfMonth(month, year) {
    var first = new Date(year, month, 1);
    first.setHours(0, 0, 0, 0);
    return first;
  }

  static lastDayOfMonth(month, year) {
    var last = new Date(year, month + 1, 0);
    last.setHours(23, 59, 59, 999);
    return last;
  }

  static daysFromMs(time) {
    return time / DateUtils.days(1);
  }

  static days(number) {
    return number * 24 * 60 * 60 * 1000;
  }

  static days30() {
    return DateUtils.days(30);
  }

  static hours24() {
    return DateUtils.hours(24);
  }

  static hours(number) {
    return number * 60 * 60 * 1000;
  }

  static formatDuration(timeInMillis) {
    if (timeInMillis == null || isNaN(timeInMillis) || timeInMillis <= 0) {
      return '0s';
    }

    const totalSeconds = Math.floor(timeInMillis / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts = [];
    if (days) parts.push(`${days}d`);
    if (hours) parts.push(`${hours}h`);
    if (minutes) parts.push(`${minutes}m`);
    if (seconds || parts.length === 0) parts.push(`${seconds}s`);

    return parts.join(' ');
  }

  static now() {
    return Date.now();
  }

  static weeksAgo(numberOfWeeks) {
    var aWeek = 7 * DateUtils.hours24();
    return aWeek * numberOfWeeks;
  }

  static JANUARY = 0;
  static FEBRUARY = 1;
  static MARCH = 2;
  static APRIL = 3;
  static MAY = 4;
  static JUNE = 5;
  static JULY = 6;
  static AUGUST = 7;
  static SEPTEMBER = 8;
  static OCTOBER = 9;
  static NOVEMBER = 10;
  static DECEMBER = 11;


  static daysInMonth(year, month) {
    if (year) {
      //
    }
    var days = 30;
    switch (month) {
      case DateUtils.JANUARY:
      case DateUtils.MARCH:
      case DateUtils.MAY:
      case DateUtils.JULY:
      case DateUtils.AUGUST:
      case DateUtils.OCTOBER:
      case DateUtils.DECEMBER:
        days = 31;
        break;

      case DateUtils.FEBRUARY:
        days = 28;
        break;
      default:
        days = 30;
        break;
    }
    return days;
  }

  static monthName(month, abbreviated) {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var name = months[month];
    if (abbreviated && name) {
      name = name.substring(0, 3);
    }
    return name;
  }

  static formatHours(decimalHours) {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return decimalHours < 1 ? `${minutes}m` : minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
  }

  static formatDays(timeInMillis, daysOnly = true) {
    timeInMillis = Math.abs(timeInMillis);
    if (timeInMillis == null || isNaN(timeInMillis) || timeInMillis <= 0) {
      return '0d';
    }

    const totalMinutes = Math.floor(timeInMillis / 60000);
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    if (days > 0) {
      if (hours === 0 && minutes === 0) {
        return `${days}d`;
      }
      if (daysOnly) {
        return `${days}d`;
      }
      if (minutes === 0) {
        return `${days}d ${hours}h`;
      }
      return `${days}d ${hours}h ${minutes}m`;
    }

    if (hours > 0) {
      return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
    }

    return `${minutes}m`;
  }

  static toHours(timeInMillis) {
    return timeInMillis / 3600000;
  }
}